export const CONTRACTOR_RESTRICTED_WORK_ORDER_STATUSES = [
  'Quote Approved',
  'Price Approved',
  'Price Declined',
  'Price Submitted',
  'Quote Declined',
] as const
